import { NavLink, Outlet, useOutletContext } from 'react-router'
import { useOrganization } from '@/contexts/OrganizationContext'
import { PRODUCT_KEYS } from '@/config/studioProducts'
import { AUTOMATION_TABS } from './prepacksAutomationsTabs'
import styles from './PrepacksAutomationsLayout.module.css'

/**
 * Schedules hub: a left sub-navigation over Boosts, Schedules, and History.
 * The Prepacks run queue from the parent layout is forwarded to children.
 * Tabs that need more than view access are hidden from users who lack it;
 * the routes themselves carry the full guard.
 */
export default function PrepacksAutomationsLayout() {
  const queue = useOutletContext()
  const { hasProductAccess, organizations } = useOrganization()
  const tabs = AUTOMATION_TABS.filter((tab) => (!tab.action || hasProductAccess(PRODUCT_KEYS.PREPACKS, tab.action)) && (!tab.role || (organizations || []).some((org) => org.role === tab.role)))
  return (
    <div className={styles.hub}>
      <nav className={styles.subnav} aria-label="Schedules">
        <p className={styles.eyebrow}>Schedules</p>
        {tabs.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) => `${styles.link} ${isActive ? styles.linkActive : ''}`}
          >
            <Icon className="h-4 w-4" aria-hidden="true" />
            {label}
          </NavLink>
        ))}
      </nav>
      <div className={styles.content}>
        <Outlet context={queue} />
      </div>
    </div>
  )
}
